// extracted by mini-css-extract-plugin
export default {"NoticeList":"NoticesCategoriesList_NoticeList__7iKup","NoticeText":"NoticesCategoriesList_NoticeText__S821w"};